<template>
	<div>
		<h1>Legitimierung</h1>
		<b-container>
			<div v-if="!valid">Dieser Link ist nicht mehr gültig.</div>
			<template v-else>
				<div v-if="success">
					Ausweis erfolgreich hochgeladen, du kannst nun im Prozess fortfahren.
				</div>
				<template v-else>
					<div>
						Hier kannst du deinen Ausweis hochladen. Sobald dies erledigt ist, kannst du im Prozess
						fortfahren.
					</div>
					<b-row class="mt-4">
						<b-col md="10">
							<FormGroup>
								<FileInput v-model="file"/>
							</FormGroup>
							<template v-if="file">
								<FormGroup
									label="Die hinaufgeladene Datei enthält einen amtlichen Lichtbildausweis von mir persönlich mit einem einem Foto von meinem eigenen Gesicht:"
									:state="face !== false"
									invalid-feedback="Bitte verwende ein persönliches Ausweisdokument von dir mit einem Foto von deinem Gesicht."
									feedback-beneath
									class="mt-3"
								>
									<RadioGroup
										v-model="face"
										:options="faceOptions"
									/>
								</FormGroup>
								<FormGroup
									label="Der Text des Ausweises ist gut leserlich und auf dem Foto ist mein Gesicht klar sichtbar:"
									:state="clearness !== false"
									invalid-feedback="Bitte lade ein gut leserliches Ausweisdokument hoch  Button mit entsprechender Rückleitung zum Upload."
									feedback-beneath
									class="mt-3"
								>
									<RadioGroup
										v-model="clearness"
										:options="clearnessOptions"
									/>
								</FormGroup>
								<div class="mt-3">
									<Button
										text="Diesen Ausweis hochladen"
										:disabled="!dataValid || uploading"
										:loading="uploading"
										@click="upload"
									/>
								</div>
							</template>
						</b-col>
						<b-col md="2">
							<div v-if="file" class="mt-1">
								<b-img :src="file.base64" fluid/>
							</div>
						</b-col>
					</b-row>
				</template>
			</template>
		</b-container>
	</div>
</template>

<script>
import FormGroup from "@/vue/common/form/Group";
import Button from "@/vue/common/Button";
import RadioGroup from "@/vue/common/form/RadioGroup";
import FileInput from "@/vue/legitimation/identification/FileInput";
import {isDefined} from "@/helper/Value";
import Loading from "@/vue/common/Loading";
import Upload from "@/api/identification/Upload";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";

export default {

	components: {
		Loading,
		Button,
		FileInput,
		RadioGroup,
		FormGroup,
	},

	props: {
		identificationId: {
			type: String,
			required: true,
		},
		valid: {
			type: Boolean,
			required: true,
		},
	},

	data ()
	{
		return {
			file: null,
			face: undefined,
			faceOptions: [
				{value: true, text: 'Ja'},
				{value: false, text: 'Nein'},
			],
			clearness: undefined,
			clearnessOptions: [
				{value: true, text: 'Ja'},
				{value: false, text: 'Nein'},
			],
			uploading: false,
			success: false,
		};
	},

	computed: {
		faceValid ()
		{
			return !this.file || this.face === true;
		},
		clearnessValid ()
		{
			return !this.file || this.clearness === true;
		},
		dataValid ()
		{
			return isDefined(this.file)
				&& this.faceValid
				&& this.clearnessValid;
		},
	},

	methods: {
		async upload ()
		{
			if (!this.dataValid)
			{
				return;
			}

			this.uploading = true;

			try
			{
				await new Upload()
					.setIdentificationId(this.identificationId)
					.setFile(this.file)
					.call();

				this.success = true;
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}

			this.uploading = true;
		}
	}
}
</script>
